export default "__VITE_ASSET__31335d92__"